<section
  class="landing-a__section landing-a__section--muted landing-a__how-it-works-section"
  id="how-it-works"
  appLandingReveal="landing-a__how-it-works-section--visible"
>
  <div class="landing-a__container">
    <div class="landing-a__section-heading">
      <h2>{{ 'landing.landing_1.how_it_works.title' | translate }}</h2>
      <p>{{ 'landing.landing_1.how_it_works.subtitle' | translate }}</p>
    </div>

    <div class="landing-a__steps">
      @for (step of steps; track step; let index = $index) {
        <article class="landing-a__step">
          <div class="landing-a__step-badge">
            <span class="landing-a__step-badge-number">{{ index + 1 }}</span>
          </div>
          <h3>{{ 'landing.landing_1.how_it_works.steps.' + step + '.title' | translate }}</h3>
          <p>{{ 'landing.landing_1.how_it_works.steps.' + step + '.description' | translate }}</p>
        </article>
      }
    </div>
  </div>
</section>
